module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 10
// module chunks = 0